module.exports = __webpack_public_path__ + "static/media/1_TSUTAYA - Kyushu.b7a30196.jpg";